import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

const CHART_KEYS = ["a", "b", "c", "d"];

const ChartPageSkeleton = () => (
	<Box sx={{ width: "100%", pt: 2 }}>
		<Stack direction="row" spacing={2} sx={{ mb: 3, flexWrap: "wrap", gap: 1 }}>
			<Skeleton
				variant="rectangular"
				width={120}
				height={40}
				sx={{ borderRadius: 1 }}
			/>
			<Skeleton
				variant="rectangular"
				width={160}
				height={40}
				sx={{ borderRadius: 1 }}
			/>
			<Skeleton
				variant="rectangular"
				width={160}
				height={40}
				sx={{ borderRadius: 1 }}
			/>
			<Skeleton
				variant="rectangular"
				width={140}
				height={40}
				sx={{ borderRadius: 1 }}
			/>
		</Stack>
		<Grid container spacing={2}>
			{CHART_KEYS.map((key) => (
				<Grid size={{ xs: 12, md: 6 }} key={key}>
					<Paper sx={{ p: 2 }}>
						<Skeleton variant="text" width={120} height={24} sx={{ mb: 1 }} />
						<Skeleton
							variant="rectangular"
							height={200}
							sx={{ borderRadius: 1 }}
						/>
					</Paper>
				</Grid>
			))}
		</Grid>
	</Box>
);

export default ChartPageSkeleton;
